import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.brandColors.slate.ink,
        color: 'white',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
    },
    logo: {
        fontWeight: 900,
        fontSize: '3rem',
        background: `linear-gradient(45deg, ${theme.palette.brandColors.cherry.bold}, ${theme.palette.brandColors.mandarin.bold})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        letterSpacing: '-1px',
        marginBottom: theme.spacing(4),
    },
    loader: {
        color: theme.palette.brandColors.cherry.regular,
        marginBottom: theme.spacing(2),
    },
    message: {
        opacity: 0.7,
        fontSize: '1.2rem',
        animation: '$pulse 2s infinite ease-in-out',
    },
    '@keyframes pulse': {
        '0%': { opacity: 0.5 },
        '50%': { opacity: 1 },
        '100%': { opacity: 0.5 },
    }
}));

export const RoomLoader: React.FC = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <div className={classes.logo}>
                IneoSpace
            </div>
            <CircularProgress size={60} className={classes.loader} thickness={4} />
            <Typography variant="body1" className={classes.message}>
                Joining Space...
            </Typography>
        </Box>
    );
};
